import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { createContext, useMemo, forwardRef, useContext } from 'react';
import { css, useTheme, jsx } from '@emotion/react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { textStyles } from '@paypalcorp/pp-react-text';
import { devWarning, utilStyles } from '@paypalcorp/pp-react-utils';
import { math } from 'polished';
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61;
function styles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    devWarning('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }
  var _utilStyles = utilStyles(tokens),
    mediaQuery = _utilStyles.mediaQuery;
  var sysBorderThicknessNormal = tokens.sysBorderThicknessNormal,
    sysBorderRadiusLg = tokens.sysBorderRadiusLg,
    sysSpaceXs = tokens.sysSpaceXs,
    sysSpaceSm = tokens.sysSpaceSm,
    sysSpaceMd = tokens.sysSpaceMd,
    sysSpaceLg = tokens.sysSpaceLg,
    sysElevationBlurBase = tokens.sysElevationBlurBase,
    sysColorBackgroundSurface = tokens.sysColorBackgroundSurface,
    sysColorBackgroundMain = tokens.sysColorBackgroundMain,
    sysColorStructureBorderHighContrast = tokens.sysColorStructureBorderHighContrast,
    sysColorSelectedRangeMain = tokens.sysColorSelectedRangeMain,
    sysColorSelectedRangeContrast = tokens.sysColorSelectedRangeContrast,
    sysSizeTapTargetDefault = tokens.sysSizeTapTargetDefault,
    sysSizeMediaMd = tokens.sysSizeMediaMd;
  var _textStyles = textStyles(tokens),
    textBody = _textStyles.body,
    bodyStrong = _textStyles.bodyStrong,
    titleStrong = _textStyles.titleStrong;
  var _utilStyles2 = utilStyles(tokens),
    elevationStyles = _utilStyles2.elevationStyles;
  var responsiveTableBase = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    label: r_table_base;\n    border-spacing: 0;\n    border-collapse: separate;\n    border: none;\n    table-layout: fixed;\n    overflow: auto;\n    width: 100%;\n  "])));
  var summaryWrapper = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    label: summary_wrap;\n    @media screen and (max-width: ", ") {\n      border: ", " solid\n        ", ";\n      border-end-start-radius: ", ";\n      border-end-end-radius: ", ";\n    }\n  "])), sysSizeMediaMd, sysBorderThicknessNormal, sysColorStructureBorderHighContrast, sysBorderRadiusLg, sysBorderRadiusLg);
  var fixedFirstColumn = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    label: fixed1st;\n    display: block;\n  "])));
  var thead = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    label: thead;\n    [data-responsive='true'] & {\n      @media screen and (max-width: ", ") {\n        display: none;\n      }\n    }\n  "])), sysSizeMediaMd);
  var tbody = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    label: tbody;\n    background-color: ", ";\n  "])), sysColorBackgroundSurface);
  var tfoot = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    label: tfoot;\n    background-color: ", ";\n  "])), sysColorBackgroundSurface);
  var rowBase = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    label: row_base;\n    background-color: ", ";\n    border-bottom: ", " solid ", ";\n  "])), sysColorBackgroundSurface, sysSpaceXs, sysColorBackgroundMain);
  var rowSelected = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    label: row_selected;\n    background-color: ", ";\n    color: ", ";\n  "])), sysColorSelectedRangeMain, sysColorSelectedRangeContrast);
  var rowResponsive = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    label: row_resp;\n    @media screen and (max-width: ", ") {\n      display: grid;\n      width: 100%;\n      grid-template-areas:\n        'a1 a2 a3'\n        'b1 b2 b3';\n      grid-template-columns: auto 1fr auto;\n      gap: 0 ", ";\n      padding: ", " 0;\n\n      thead th {\n        display: none;\n      }\n    }\n  "])), sysSizeMediaMd, sysSpaceSm, sysSpaceMd);
  var rowHeading = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    label: row_head;\n    white-space: nowrap;\n  "])));
  var rowFooting = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    label: row_foot;\n    background-color: ", ";\n    white-space: nowrap;\n  "])), sysColorBackgroundMain);
  var rowSummaryItem = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    label: row_item;\n    border-bottom: none;\n  "])));
  var rowSummaryAdjust = css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    label: row_adj;\n    border-bottom: none;\n    border-top: ", " solid\n      ", ";\n  "])), sysBorderThicknessNormal, sysColorStructureBorderHighContrast);
  var rowSummaryTotal = css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    label: row_total;\n    border-top: ", " solid\n      ", ";\n    background-color: ", ";\n  "])), sysBorderThicknessNormal, sysColorStructureBorderHighContrast, sysColorBackgroundMain); // NOTE: setting height on a cell is equivalent to min-height
  // Height allows for icon button + 12px above and below 44px + 12px + 12px

  var cellBase = css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    ", "\n    padding: ", ";\n    height: ", ";\n    vertical-align: middle;\n    border-bottom: ", " solid\n      ", ";\n  "])), textBody({
    label: 'cell',
    color: 'inherit'
  }), sysSpaceMd, math("".concat(sysSizeTapTargetDefault, " + (").concat(sysSpaceMd, " * 2 )")), sysBorderThicknessNormal, sysColorStructureBorderHighContrast);
  var cellResponsive = css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    label: cell_resp;\n    @media screen and (min-width: ", ") {\n      &:first-of-type {\n        padding-left: ", ";\n      }\n      &:last-of-type {\n        padding-right: ", ";\n      }\n    }\n    @media screen and (max-width: ", ") {\n      display: block;\n      height: auto;\n      padding: ", " ", ";\n      min-width: ", ";\n      border: none !important;\n    }\n  "])), sysSizeMediaMd, sysSpaceLg, sysSpaceLg, sysSizeMediaMd, sysSpaceXs, sysSpaceSm, sysSpaceMd);
  var headRowCell = css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    ", "\n    position: sticky;\n    top: 0;\n    vertical-align: middle;\n    z-index: 1;\n    &:first-of-type {\n      z-index: 2;\n    }\n  "])), titleStrong({
    label: 'h_th'
  }));
  var footerRowCell = css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    ", "\n    vertical-align: middle;\n    z-index: 1;\n    &:first-of-type {\n      z-index: 2;\n    }\n  "])), titleStrong({
    label: 'f_th'
  }));
  var dataHeaderCell = css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    ", "\n    background-color: ", ";\n  "])), bodyStrong(), sysColorBackgroundMain);
  var summaryHeaderCell = css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    ", "\n    background-color: ", ";\n  "])), titleStrong({
    label: 'sum_th'
  }), sysColorBackgroundSurface);
  var summaryFooterCell = css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    label: f_th;\n    ", "\n    background-color: ", ";\n  "])), titleStrong({
    label: 'total_th'
  }), sysColorBackgroundMain);
  var stickyRowHeader = css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    label: sticky_h_th;\n    position: sticky;\n    top: 0;\n    z-index: 1; // No token, just need this to be on top of other headers\n    &:first-of-type {\n      z-index: 2;\n    }\n  "])));
  var stickyRowFooter = css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    label: sticky_f_th;\n    ", "\n    position: sticky;\n    bottom: 0;\n    vertical-align: middle;\n  "])), titleStrong({
    label: ''
  }));
  var stickyColHeading = css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n    label: sticky_col;\n    &:first-of-type {\n      position: sticky;\n      left: 0;\n    }\n  "])));
  var cellHeading = css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n    label: th;\n    text-align: start;\n    padding: ", ";\n    tbody &:first-of-type {\n      ", "\n      background-color: inherit;\n    }\n  "])), sysSpaceMd, titleStrong({
    label: ''
  }));
  var legacyTh = css(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n    th {\n      text-align: start;\n    }\n  "])));
  var tableBase = css(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    ", "\n    border-spacing: 0;\n    border-collapse: separate;\n  "])), textBody({
    label: 'table_base'
  }));
  var legacyTableBase = css(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n    label: legacy_table;\n    > tbody {\n      > tr {\n        background-color: ", ";\n        > td,\n        > th {\n          border-bottom: ", " solid\n            ", ";\n          border-top: ", " solid transparent;\n        }\n\n        > td {\n          padding: ", ";\n          &:first-of-type {\n            padding-left: ", ";\n          }\n          &:last-of-type {\n            padding-right: ", ";\n          }\n        }\n        > th {\n          padding: ", ";\n          &:first-of-type {\n            padding-left: ", ";\n          }\n        }\n      }\n    }\n\n    > thead > tr {\n      background-color: ", ";\n      white-space: nowrap;\n\n      > th {\n        position: relative;\n        ", "\n        border-bottom: ", " solid ", ";\n        padding: ", ";\n\n        &:last-of-type {\n          padding-right: ", ";\n        }\n        &:first-of-type {\n          padding-left: ", ";\n        }\n      }\n    }\n  "])), sysColorBackgroundSurface, sysBorderThicknessNormal, sysColorStructureBorderHighContrast, sysBorderThicknessNormal, sysSpaceMd, sysSpaceLg, sysSpaceLg, sysSpaceMd, sysSpaceLg, sysColorBackgroundMain, bodyStrong(), sysBorderThicknessNormal, sysColorStructureBorderHighContrast, sysSpaceMd, sysSpaceLg, sysSpaceLg);
  var scrollContext = css(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n    label: scroll_context;\n    display: inline-block;\n    overflow: auto;\n    max-height: 100%;\n    width: 100%;\n  "])));
  var scrollContextTable = css(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n    label: scroll_context_table;\n    border: none;\n    table-layout: fixed;\n    display: block;\n    overflow: auto;\n\n    > thead {\n      position: sticky;\n      top: 0;\n      z-index: 10;\n\n      /* If this table can scroll, remove the border beneath the header row and replace it with a drop shadow */\n      > tr {\n        position: relative;\n        ", ";\n        > th {\n          border-bottom: none;\n          position: sticky;\n          top: 0;\n          background-color: ", ";\n        }\n      }\n    }\n    > tbody {\n      > tr {\n        > th {\n          ", "\n          clip-path: polygon(0 0, 0 100%, calc(100% + ", ") 100%, calc(100% + ", ") 0);\n          &:first-of-type {\n            background-color: inherit;\n            position: sticky;\n            left: 0;\n          }\n        }\n        > td:nth-of-type(2) {\n          padding-left: ", ";\n        }\n      }\n    }\n  "])), elevationStyles.filterLevel1, sysColorBackgroundMain, elevationStyles.level1Horizontal, sysElevationBlurBase, sysElevationBlurBase, sysSpaceMd); // the clip-path below clips the individual shadows and prevents
  // them from bleeding over into other cells. --BCC

  var fixedFirstColumnTable = css(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n    label: fixed_first_column_table;\n    > thead > tr > th:first-of-type {\n      position: sticky;\n      border-bottom: none;\n      ", "\n      clip-path: polygon(0 0, 0 100%, calc(100% + ", ") 100%, calc(100% + ", ") 0);\n      z-index: 2;\n      left: 0;\n\n      &:after {\n        background-color: inherit;\n      }\n    }\n    > tbody > tr > th:first-of-type {\n      position: sticky;\n      left: 0;\n    }\n\n    [dir='rtl'] & {\n      > thead > tr > th:first-of-type {\n        clip-path: polygon(\n          -", " 0,\n          -", " 100%,\n          100% 100%,\n          100% -", "\n        );\n        right: 0;\n        left: unset;\n      }\n      > tbody > tr > th {\n        position: sticky;\n        left: unset;\n        right: 0;\n        clip-path: polygon(\n          -", " 0,\n          -", " 100%,\n          100% 100%,\n          100% -", "\n        );\n      }\n    }\n  "])), elevationStyles.level1Horizontal, sysElevationBlurBase, sysElevationBlurBase, sysElevationBlurBase, sysElevationBlurBase, sysElevationBlurBase, sysElevationBlurBase, sysElevationBlurBase, sysElevationBlurBase);
  var customWidth = function (width) {
    return css(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n    label: cust_width;\n    width: ", ";\n  "])), width);
  };
  var mobileGridZones = {
    zone_hidden: css(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n      label: m_hide;\n      @media screen and (max-width: ", ") {\n        display: none;\n      }\n    "])), sysSizeMediaMd),
    zone_a1: css(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n      label: m_a1;\n      @media screen and (max-width: ", ") {\n        grid-area: a1;\n      }\n    "])), sysSizeMediaMd),
    zone_a2: css(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n      label: m_a2;\n      @media screen and (max-width: ", ") {\n        grid-area: a2;\n      }\n    "])), sysSizeMediaMd),
    zone_a3: css(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n      label: m_a3;\n      @media screen and (max-width: ", ") {\n        grid-area: a3;\n        text-align: end;\n        width: 100%;\n      }\n    "])), sysSizeMediaMd),
    zone_a12: css(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n      label: m_a12;\n      @media screen and (max-width: ", ") {\n        grid-area: a1 / a1 / a2 / a2;\n      }\n    "])), sysSizeMediaMd),
    zone_a23: css(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n      label: m_a23;\n      @media screen and (max-width: ", ") {\n        grid-area: a2 / a2 / a3 / a3;\n        width: 100%;\n      }\n    "])), sysSizeMediaMd),
    zone_a123: css(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n      label: m_a123;\n      @media screen and (max-width: ", ") {\n        grid-area: a1 / a1 / a3 / a3;\n      }\n    "])), sysSizeMediaMd),
    zone_b1: css(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n      label: m_b1;\n      @media screen and (max-width: ", ") {\n        grid-area: b1;\n      }\n    "])), sysSizeMediaMd),
    zone_b2: css(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n      label: m_b2;\n      @media screen and (max-width: ", ") {\n        grid-area: b2;\n      }\n    "])), sysSizeMediaMd),
    zone_b3: css(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n      label: m_b3;\n      @media screen and (max-width: ", ") {\n        grid-area: b3;\n        text-align: end;\n        width: 100%;\n      }\n    "])), sysSizeMediaMd),
    zone_b12: css(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n      label: m_b12;\n      @media screen and (max-width: ", ") {\n        grid-area: b1 / b1 / b2 / b2;\n      }\n    "])), sysSizeMediaMd),
    zone_b23: css(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n      label: m_b23;\n      @media screen and (max-width: ", ") {\n        grid-area: b2 / b2 / b3 / b3;\n        width: 100%;\n      }\n    "])), sysSizeMediaMd),
    zone_b123: css(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n      label: m_b123;\n      @media screen and (max-width: ", ") {\n        grid-area: b1 / b1 / b3 / b3;\n        width: 100%;\n      }\n    "])), sysSizeMediaMd),
    zone_ab1: css(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n      label: m_ab1;\n      @media screen and (max-width: ", ") {\n        grid-area: a1 / a1 / b1 / b1;\n      }\n    "])), sysSizeMediaMd),
    zone_ab2: css(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n      label: m_ab2;\n      @media screen and (max-width: ", ") {\n        grid-area: a2 / a2 / b2 / b2;\n      }\n    "])), sysSizeMediaMd),
    zone_ab3: css(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n      label: m_ab3;\n      @media screen and (max-width: ", ") {\n        grid-area: a3 / a3 / b3 / b3;\n        width: 100%;\n      }\n    "])), sysSizeMediaMd),
    zone_ab12: css(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n      label: m_ab12;\n      @media screen and (max-width: ", ") {\n        grid-area: a1 / a1 / b2 / b2;\n      }\n    "])), sysSizeMediaMd),
    zone_ab23: css(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n      label: m_ab23;\n      @media screen and (max-width: ", ") {\n        grid-area: a2 / a2 / b3 / b3;\n        width: 100%;\n      }\n    "])), sysSizeMediaMd),
    zone_ab123: css(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n      label: m_ab123;\n      @media screen and (max-width: ", ") {\n        grid-area: a1 / a1 / b3 / b3;\n        width: 100%;\n      }\n    "])), sysSizeMediaMd)
  };
  var columnRemaining = css(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n    label: w100;\n    width: 100%;\n  "])));
  var columnStart = css(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n    label: align_start;\n    text-align: start;\n  "])));
  var columnEnd = css(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n    label: align_end;\n    text-align: end;\n  "])));
  var columnCenter = css(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n    label: align_center;\n    text-align: center;\n  "])));
  var normalCell = css(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n    label: td_norm;\n    text-align: start;\n  "])));
  var utilityCell = css(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n    label: util_cell;\n    border-bottom: none;\n    background-color: ", ";\n  "])), sysColorBackgroundSurface);
  var summaryHeadingCell = css(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n    ", "\n    text-align: start;\n    padding: ", ";\n    border-bottom: ", " solid\n      ", ";\n  "])), titleStrong({
    label: 'sum_head'
  }), sysSpaceMd, sysBorderThicknessNormal, sysColorStructureBorderHighContrast);
  var summaryItemCell = css(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n    label: item;\n    border-bottom: none;\n    &:first-of-type {\n      border-left: ", " solid\n        ", ";\n    }\n    &:last-of-type {\n      border-right: ", " solid\n        ", ";\n    }\n  "])), sysBorderThicknessNormal, sysColorStructureBorderHighContrast, sysBorderThicknessNormal, sysColorStructureBorderHighContrast);
  var summaryAdjustCell = css(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n    label: adjust;\n    border-top: ", " solid\n      ", ";\n    border-bottom: none;\n    ", "\n    &:first-of-type {\n      border-left: ", " solid\n        ", ";\n    }\n    &:last-of-type {\n      border-right: ", " solid\n        ", ";\n    }\n  "])), sysBorderThicknessNormal, sysColorStructureBorderHighContrast, bodyStrong(), sysBorderThicknessNormal, sysColorStructureBorderHighContrast, sysBorderThicknessNormal, sysColorStructureBorderHighContrast);
  var summaryTotalCell = css(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n    label: summary;\n    background-color: ", ";\n    ", "\n    border-top: ", " solid ", ";\n    &:first-of-type {\n      border-end-start-radius: ", ";\n      border-left: ", " solid\n        ", ";\n    }\n    &:last-of-type {\n      border-end-end-radius: ", ";\n      border-right: ", " solid\n        ", ";\n    }\n  "])), sysColorBackgroundMain, titleStrong(), sysBorderThicknessNormal, sysColorStructureBorderHighContrast, sysBorderRadiusLg, sysBorderThicknessNormal, sysColorStructureBorderHighContrast, sysBorderRadiusLg, sysBorderThicknessNormal, sysColorStructureBorderHighContrast);
  return {
    tableBase: tableBase,
    legacyTableBase: legacyTableBase,
    legacyTh: legacyTh,
    summaryWrapper: summaryWrapper,
    fixedFirstColumnTable: fixedFirstColumnTable,
    scrollContext: scrollContext,
    scrollContextTable: scrollContextTable,
    columnRemaining: columnRemaining,
    getAlignment: function getAlignment(align) {
      switch (align) {
        case 'right':
        case 'end':
          return columnEnd;
        case 'center':
          return columnCenter;
        case 'left':
        case 'start':
        default:
          return columnStart;
      }
    },
    responsiveTableBase: responsiveTableBase,
    // Base style for a responsive table
    fixedFirstColumn: fixedFirstColumn,
    //
    thead: thead,
    // Base styles for a head, body, and foot sections
    tbody: tbody,
    tfoot: tfoot,
    cellBase: cellBase,
    // Styles shared by all table cells
    cellResponsive: cellResponsive,
    cellHeading: cellHeading,
    // Styles specific to heading cells
    mobileWidth: function mobileWidth(widthStr) {
      return mediaQuery("width: ".concat(widthStr));
    },
    // Width to use for screens < md size
    mobileAlign: function mobileAlign(align) {
      return mediaQuery("align: ".concat(align));
    },
    // Alignment to use for screens < md size
    dataHeaderCell: dataHeaderCell,
    summaryHeaderCell: summaryHeaderCell,
    summaryFooterCell: summaryFooterCell,
    rowBase: rowBase,
    // Styles shared by all table rows
    rowSelected: rowSelected,
    rowResponsive: rowResponsive,
    rowHeading: rowHeading,
    // Styles specific to a heading row
    rowFooting: rowFooting,
    // Styles specific to a footer row
    rowSummaryItem: rowSummaryItem,
    rowSummaryAdjust: rowSummaryAdjust,
    rowSummaryTotal: rowSummaryTotal,
    mobileGridZones: mobileGridZones,
    // Defines 6 zones to which a responsive cell may move
    customWidth: customWidth,
    // Defines a prop-specified width
    headRowCell: headRowCell,
    footerRowCell: footerRowCell,
    stickyRowHeader: stickyRowHeader,
    stickyRowFooter: stickyRowFooter,
    stickyColHeading: stickyColHeading,
    normalCell: normalCell,
    utilityCell: utilityCell,
    summaryHeadingCell: summaryHeadingCell,
    summaryItemCell: summaryItemCell,
    summaryAdjustCell: summaryAdjustCell,
    summaryTotalCell: summaryTotalCell
  };
}
var DEFAULT_TABLE_CONTEXT = {
  tableType: 'data',
  isResponsive: false,
  isSticky: false
};
var PPTableContext = createContext(DEFAULT_TABLE_CONTEXT);
var _excluded = ["className", "fixedFirstColumn", "children", "tableType", "isLegacy"];
var ResponsiveTable = function (_ref) {
  var className = _ref.className,
    _ref$fixedFirstColumn = _ref.fixedFirstColumn,
    fixedFirstColumn = _ref$fixedFirstColumn === void 0 ? false : _ref$fixedFirstColumn,
    children = _ref.children,
    tableType = _ref.tableType,
    isLegacy = _ref.isLegacy,
    rest = _objectWithoutProperties(_ref, _excluded);
  var tokens = useTheme();
  var tableStyles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);
  var tableCss = [tableStyles.responsiveTableBase, fixedFirstColumn && tableStyles.fixedFirstColumn];
  var wrapperCss = [tableStyles.scrollContext, tableType === 'summary' && tableStyles.summaryWrapper];
  return jsx(PPTableContext.Provider, {
    value: {
      tableType: 'data',
      isResponsive: true,
      isSticky: true
    },
    "data-ppui": "true"
  }, jsx("div", {
    css: wrapperCss,
    "data-responsive": "true",
    "data-ppui": "true"
  }, jsx("table", _extends({
    css: tableCss,
    "data-ppui-info": "table_3.19.2"
  }, rest, {
    className: className
  }), children)));
};
var _excluded$1 = ["tableContext", "className", "children", "sticky", "as"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var TableSection = forwardRef(function (props, ref) {
  var tableContext = props.tableContext,
    className = props.className,
    children = props.children,
    sticky = props.sticky,
    _props$as = props.as,
    Component = _props$as === void 0 ? 'tbody' : _props$as,
    rest = _objectWithoutProperties(props, _excluded$1);
  var context = _objectSpread(_objectSpread({}, useContext(PPTableContext)), tableContext);
  var tokens = useTheme();
  var tableStyles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);
  var css = tableStyles[Component];
  var classes = sticky ? "pp_react_sticky ".concat(className) : className;
  var newTableContext = _objectSpread({}, context);
  if (!newTableContext.hasOwnProperty('section')) {
    newTableContext.section = Component;
  }
  return jsx(PPTableContext.Provider, {
    value: newTableContext,
    "data-ppui": "true"
  }, jsx(Component, _extends({
    ref: ref,
    css: css,
    className: classes
  }, rest, {
    "data-ppui": "true"
  }), children));
});
var TableBody = function (props) {
  return jsx(TableSection, _extends({}, props, {
    as: "tbody",
    "data-ppui": "true"
  }));
};
var TableHead = function (props) {
  return jsx(TableSection, _extends({}, props, {
    as: "thead",
    "data-ppui": "true"
  }));
};
var TableFoot = function (props) {
  return jsx(TableSection, _extends({}, props, {
    as: "tfoot",
    "data-ppui": "true"
  }));
};
var TableCaption = function (props) {
  return jsx(TableSection, _extends({}, props, {
    as: "caption",
    "data-ppui": "true"
  }));
};
var _excluded$2 = ["tableContext", "isSelected", "className", "children"];
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var TableRow = forwardRef(function (props, ref) {
  var tableContext = props.tableContext,
    isSelected = props.isSelected,
    className = props.className,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded$2);
  var context = _objectSpread$1(_objectSpread$1({}, useContext(PPTableContext)), tableContext);
  var tokens = useTheme();
  var tableStyles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);
  var section = context.section,
    isResponsive = context.isResponsive;
  var rowCss = [tableStyles.rowBase, isSelected && tableStyles.rowSelected, isResponsive && tableStyles.rowResponsive, section === 'thead' && tableStyles.rowHeading, section === 'tfoot' && tableStyles.rowFooting, section === 'summaryItem' && tableStyles.rowSummaryItem, section === 'summaryAdjust' && tableStyles.rowSummaryAdjust, section === 'summaryTotal' && tableStyles.rowSummaryTotal];
  return jsx("tr", _extends({
    ref: ref,
    css: rowCss,
    className: className
  }, rest, {
    "data-ppui": "true"
  }), children);
});
var _excluded$3 = ["className", "tableContext", "mobile", "claimsRemainingSpace", "width", "span", "isHeader", "children", "align"];
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var stickableFooters = new Set(['utility', 'tfoot']);
var TableCell = forwardRef(
// eslint-disable-next-line complexity
function (props, ref) {
  var _context$section, _tableStyles$getAlign, _tableStyles$customWi, _tableStyles$mobileWi, _tableStyles$mobileAl;
  var className = props.className,
    tableContext = props.tableContext,
    mobile = props.mobile,
    claimsRemainingSpace = props.claimsRemainingSpace,
    width = props.width,
    _props$span = props.span,
    span = _props$span === void 0 ? 1 : _props$span,
    isHeader = props.isHeader,
    children = props.children,
    _props$align = props.align,
    align = _props$align === void 0 ? 'start' : _props$align,
    rest = _objectWithoutProperties(props, _excluded$3);
  var context = _objectSpread$2(_objectSpread$2({}, useContext(PPTableContext)), tableContext); // eslint-disable-next-line complexity

  var tokens = useTheme();
  var tableStyles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);
  var mobileGridZones = tableStyles.mobileGridZones,
    cellResponsive = tableStyles.cellResponsive;
  var sectionCellStyleName = "".concat((_context$section = context === null || context === void 0 ? void 0 : context.section) !== null && _context$section !== void 0 ? _context$section : 'normal', "Cell"); // At ease, typescript... it's really ok

  var sectionCss = tableStyles[sectionCellStyleName]; // To convert cellCss to farenheit multiply by 9/5 add 32... --BCC

  var cellCss = [tableStyles.cellBase, (tableContext === null || tableContext === void 0 ? void 0 : tableContext.isResponsive) && cellResponsive, isHeader && function getHeaderStyles(styleSet, headerContext) {
    var tableType = headerContext.tableType,
      isSticky = headerContext.isSticky,
      section = headerContext.section,
      isFirst = headerContext.isFirst;
    var css = [styleSet.cellHeading, section === 'thead' && styleSet.headerRow, section === 'thead' && tableType === 'data' && styleSet.dataHeaderCell, section === 'thead' && tableType === 'summary' && styleSet.summaryHeaderCell, section === 'thead' && isSticky && styleSet.stickyColHeader, section === 'tfoot' && styleSet.footerRow, stickableFooters.has(section) && isSticky && styleSet.stickyRowFooter, section === 'tfoot' && tableType === 'summary' && styleSet.summaryFooterCell, section === 'utility' && styleSet.utilityCell, section === 'tbody' && isSticky && isFirst && styleSet.stickyColHeading];
    return css;
  }(tableStyles, context), sectionCss, (_tableStyles$getAlign = tableStyles.getAlignment) === null || _tableStyles$getAlign === void 0 ? void 0 : _tableStyles$getAlign.call(tableStyles, align), width && ((_tableStyles$customWi = tableStyles.customWidth) === null || _tableStyles$customWi === void 0 ? void 0 : _tableStyles$customWi.call(tableStyles, width)), (mobile === null || mobile === void 0 ? void 0 : mobile.placement) && cellResponsive, (mobile === null || mobile === void 0 ? void 0 : mobile.placement) && (mobileGridZones === null || mobileGridZones === void 0 ? void 0 : mobileGridZones["zone_".concat(mobile.placement)]),
  // TODO - move this logic into styles.tsx
  (mobile === null || mobile === void 0 ? void 0 : mobile.width) && ((_tableStyles$mobileWi = tableStyles.mobileWidth) === null || _tableStyles$mobileWi === void 0 ? void 0 : _tableStyles$mobileWi.call(tableStyles, mobile.width)), (mobile === null || mobile === void 0 ? void 0 : mobile.align) && ((_tableStyles$mobileAl = tableStyles.mobileAlign) === null || _tableStyles$mobileAl === void 0 ? void 0 : _tableStyles$mobileAl.call(tableStyles, mobile.align))];
  var Component = isHeader ? 'th' : 'td';
  if (claimsRemainingSpace) {
    cellCss.push(tableStyles.columnRemaining);
  }
  var cellProps = _objectSpread$2({}, rest);
  if (span > 1) {
    // @ts-ignore
    cellProps.colSpan = span; // There is no CSS way to do colspan!
  }
  return jsx(Component, _extends({
    ref: ref,
    css: cellCss,
    className: className
  }, cellProps, {
    "data-ppui": "true"
  }), children);
});
var TableHeadingCell = function (props) {
  return jsx(TableCell, _extends({
    isHeader: true
  }, props, {
    "data-ppui": "true"
  }));
};
var _excluded$4 = ["className", "scroll", "fixedFirstColumn", "children", "align", "isFullWidth", "isLegacy"];
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Table = function (_ref) {
  var _tableStyles$getAlign;
  var className = _ref.className,
    _ref$scroll = _ref.scroll,
    scroll = _ref$scroll === void 0 ? false : _ref$scroll,
    _ref$fixedFirstColumn = _ref.fixedFirstColumn,
    fixedFirstColumn = _ref$fixedFirstColumn === void 0 ? false : _ref$fixedFirstColumn,
    children = _ref.children,
    align = _ref.align,
    isFullWidth = _ref.isFullWidth,
    _ref$isLegacy = _ref.isLegacy,
    isLegacy = _ref$isLegacy === void 0 ? true : _ref$isLegacy,
    rest = _objectWithoutProperties(_ref, _excluded$4);
  var tokens = useTheme();
  var tableStyles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);
  var cssVal = [[scroll || fixedFirstColumn] && tableStyles.scrollContext];
  var tableCss = [tableStyles.tableBase, isLegacy && tableStyles.legacyTableBase, isLegacy && tableStyles.legacyTh, (_tableStyles$getAlign = tableStyles.getAlignment) === null || _tableStyles$getAlign === void 0 ? void 0 : _tableStyles$getAlign.call(tableStyles, align), isFullWidth && tableStyles.columnRemaining, scroll && tableStyles.scrollContextTable, fixedFirstColumn && [tableStyles.scrollContextTable, tableStyles.fixedFirstColumnTable]];
  var context = _objectSpread$3(_objectSpread$3({}, DEFAULT_TABLE_CONTEXT), {}, {
    isSticky: scroll
  });
  var renderTable = jsx(PPTableContext.Provider, {
    value: context,
    "data-ppui": "true"
  }, jsx("table", _extends({
    css: tableCss,
    "data-ppui-info": "table_3.19.2"
  }, rest, {
    className: className
  }), children));
  return scroll || fixedFirstColumn ? jsx("div", {
    css: cssVal,
    "data-ppui": "true"
  }, renderTable) : renderTable;
};
export { DEFAULT_TABLE_CONTEXT, PPTableContext, ResponsiveTable, Table, TableBody, TableCaption, TableCell, TableFoot, TableHead, TableHeadingCell, TableRow, TableSection, styles as tableStyles };